import React from 'react';
import { useToggleIsEditing } from 'components/editors/NewEditor/hooks/useIsEditing';
import Button from 'components/common/Button';
import './DoneButton.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import useIsMobile from 'hooks/useIsMobile';

export const DoneButton = ({ onClick }) => {
  const toggleIsEditing = useToggleIsEditing();
  const isMobile = useIsMobile();
  return (
    <Button className="done-button" onClick={onClick || toggleIsEditing}>
      {isMobile ? <FontAwesomeIcon icon={faArrowLeft} className="icon-button" /> : 'Done'}
    </Button>
  );
};

export default DoneButton;
